import { CONFIG } from "~/config";

const MAX_POINTS = 1000; // omezeni na pocet
const URL = "/gpxserver/";

export interface IImportPoint {
	altitude: null,
	description: string;
	link: string;
	mark: {
		lat: number;
		lon: number;
	},
	possibleEntities: Array<string>;
	sequenceId: number;
	timestamp: number;
	title: string;
	type: "point";
}

export interface IImportRoute {
	data: {
		data: Array<{
			altitude: string;
			route: string;
			timestamps: string;
		}>;
		info: Record<string, never>;
	};
	description: string;
	possibleEntities: Array<string>;
	sequenceId: number;
	title: string;
	type: "route";
}

export interface IImportTrack {
	data: {
		data: Array<{
			altitude: string;
			route: string;
			timestamps: string;
		}>;
		info?: {
			startTime?: number;
			totalTime?: number;
		};
	};
	description: string;
	possibleEntities: Array<string>;
	sequenceId: number;
	title: string;
	type: "track";
}

export interface IImportResponse {
	data: {
		points: Array<IImportPoint>;
		routes: Array<IImportRoute>;
		tracks: Array<IImportTrack>;
	};
	warnings: Array<{
		key: string;
		[key: string]: any;
	}>;
}

export function parseFiles(files: Array<File>): Promise<{
	names: Array<string>;
	data: IImportResponse["data"];
	warnings: IImportResponse["warnings"];
	maxPointsCount: number;
	maxPointsWarning: boolean;
}> {
	return new Promise((resolve, reject) => {
		const formData = new FormData();

		files.forEach(file => formData.append("file", file));

		Mapy.Util.request<IImportResponse>(`${CONFIG.requestUrl + URL}import/`, {
			method: "POST",
			type: "json",
			form: formData,
		}).promise.then(responseData => {
			let maxPointsWarning = false;

			// omezeni na body
			if (responseData.data.data.points.length > MAX_POINTS) {
				maxPointsWarning = true;
				responseData.data.data.points = responseData.data.data.points.slice(0, MAX_POINTS);
			}

			resolve({
				// jmeno souboru
				names: files.map(file => file.name),
				data: responseData.data.data,
				warnings: responseData.data.warnings,
				maxPointsCount: MAX_POINTS,
				maxPointsWarning,
			});
		}, ex => {
			reject(ex);
		});
	});
}

// duplicity: check 409, ignore
export function save(items = [], folderId, duplicity = ""): Promise<{
	new: Array<any>;
	items: Array<any>;
	duplicityCount: number;
	error: string;
	conflict: boolean;
}> {
	return new Promise((resolve, reject) => {
		const opts = {
			/* eslint-disable camelcase */
			link_track_to: folderId,
			/* eslint-enable camelcase */
			...duplicity ? { duplicity } : {},
		};

		const outputData = {
			new: [],
			items: [],
			duplicityCount: 0,
			error: "",
			conflict: false,
		};

		if (!items.length) {
			resolve(outputData);

			return;
		}

		// pridame folder id - krome tracku
		items.forEach(item => {
			if (item.type !== "track") {
				// eslint-disable-next-line camelcase
				item.parent_id = folderId;
			}
		});

		Mapy.ProviderMapyBox.createMulti(items, opts).then(() => {
			resolve(outputData);
		}, ex => {
			// konflikt
			if (ex.status === 409) {
				outputData.conflict = true;

				ex.results.forEach((result, index) => {
					const item = items[index];

					if (result.status === 200) {
						outputData.new.push(item);
						outputData.items.push(item);
					} else if (result.status === 409) {
						outputData.items.push(item);
						outputData.duplicityCount++;
					}
				});

				// duplicita
				resolve(outputData);
			} else {
				outputData.error = ex;
				reject(outputData);
			}
		});
	});
}
